import {TreeLinks} from "./tree-links";
import {UP_ARROW, DOWN_ARROW, LEFT_ARROW, RIGHT_ARROW, TAB, HOME, END, ENTER, SPACE, PAGE_UP, PAGE_DOWN} from '@angular/cdk/keycodes';

export class TreeItemLink {
    static nodeCount = 0;
    nodeId;
    tree: TreeLinks;
    groupTreeItem: TreeLinks;
    isExpanded;
    data;
    parent: TreeItemLink;
    rtl = false;
    keyCode;
    queryParams = null;
    fragment;
    href;
    isExternalLink;
    linkType;

    constructor(node, parent, groupTreeItem, rtl = false, urlTemplate = null) {
        if (typeof node !== 'object') {
            return;
        }

        if(node.children && node.children.length) {
            this.tree = new TreeLinks(node.children, rtl, urlTemplate) ;
            this.tree.init(this);
        }
        this.data = node;
        if(node.url) {
            this.setExternalLink(node.url)
            if(!this.isExternalLink) {
                this.setBaseLink(node.url);
                this.setQueryParams(node.url);
                this.setFragment(node.url);
            }
        } else if(urlTemplate) {
            let url = this.replaceUrlTemplate(urlTemplate, node);
            this.setBaseLink(url);
            this.setQueryParams(url);
            this.setFragment(url);
        }
        this.setLinkType();
        this.nodeId = TreeItemLink.nodeCount ++;
        this.parent = parent;
        this.groupTreeItem = groupTreeItem;
        this.rtl = rtl;
    }

    handleKeypress(event) {
        let flag = false, char = event.key;
        if (this.isPrintableCharacter(char)) {
            flag = this.printableCharacter(this, char);
        }
        if (flag) {
            event.stopPropagation();
            event.preventDefault();
        }
    }

    handleKeydown(event) {
        let flag = false;

        if (event.altKey || event.ctrlKey || event.metaKey) {
            return;
        }
        let open_arrow = this.rtl? RIGHT_ARROW : LEFT_ARROW;
        let close_arrow = this.rtl? LEFT_ARROW : RIGHT_ARROW;
        if (event.shift) {
            if (event.keyCode == SPACE || event.keyCode == ENTER) {
                event.stopPropagation();
            }
        }
        else {
            switch (event.keyCode) {
                case SPACE:
                    this.toggleNode(this);
                    break;

                case UP_ARROW:
                    if(this.groupTreeItem) {
                        this.groupTreeItem.setFocusToPreviousItem(this);
                    }
                    break;

                case DOWN_ARROW:
                    if(this.groupTreeItem) {
                        this.groupTreeItem.setFocusToNextItem(this);
                    }
                    break;

                case close_arrow:
                    if (this.isExpanded ) {
                        if(this.groupTreeItem) {
                            this.groupTreeItem.setFocusToNextItem(this);
                        }
                    }
                    else {
                        this.expandNode(this);
                    }
                    break;
                case open_arrow:
                    if (this.isExpanded) {
                        this.collapseNode(this);
                    }
                    else {
                        if(this.parent) {
                            this.parent.setFocus();
                        }
                    }
                    break;

                case HOME:
                    TreeLinks.setFocusToFirstTreeItem(this);
                    break;

                case END:
                    TreeLinks.setFocusToLastTreeItem(this);
                    break;


            }
        }

    }


    isPrintableCharacter (str) {
        return str.length === 1 && str.match(/\S/);
    }

    printableCharacter (item, char) {
        if (char == '*') {
            this.groupTreeItem.expandAllSiblingItems();
            return  true;
        }
        else {
            if (this.isPrintableCharacter(char)) {
                this.groupTreeItem.setFocusByFirstCharacter(this, char);
                return  true;
            }
        }
    }

    handleClick($event) {
        this.toggleNode(this);
        $event.stopPropagation();
        $event.preventDefault();
    }

    toggleNode(node) {
        if(node.tree) {
            node.isExpanded = !node.isExpanded;
        }
    }

    collapseNode(node) {
        if(node.tree) {
            node.isExpanded = false;
        }
    }

    expandNode(node) {
        if(node.tree) {
            node.isExpanded = true;
        }
    }

    setFocusToParentItem(currentItem) {
        currentItem.parent.setFocusToItem(parent);
    }

    setFocus() {
        document.getElementById(`side_nav_node_${this.nodeId}`).focus();
    }

    setFocusToLastItem(node) {
        if(node.isExpanded && node.tree) {
            this.setFocusToLastItem(node.tree.treeItems[node.tree.treeItems.length - 1]);
        } else {
            node.setFocus();
        }
    }

    getFirstChar() {
        return this.data.name[0];
    }

    setQueryParams(link) {
        const queryParamsString = link.split('?')[1]? link.split('?')[1] : '';
        const queryParams = {};
        if(queryParamsString) {
            queryParamsString.split('&').forEach(x => {
                const params = x.split('=');
                queryParams[params[0]] = params[1];
            });
        }
        this.queryParams = queryParams;
    }
    
    replaceUrlTemplate(urlTemplate, node) {
        const regexp = /[!][!](.*?)[!][!]/g;
        return urlTemplate.replace(regexp, ($1, $2) => {
            return node[$2];
        })
    }
    
    setBaseLink(link) {
        this.href = link.split('?')[0].split('#')[0];
    }

    setFragment(link) {
        this.fragment = link.split('?')[0].split('#')[1] || null;
    }

    setExternalLink(link) {
        this.isExternalLink = /^https?:\/\//i.test(link);
        this.href = link;
    }

    setLinkType() {
        if(this.isExternalLink && this.href) {
            this.linkType = 'EXTERNAL_LINK';
        } else if(!this.isExternalLink && this.href) {
            this.linkType = 'INNER_LINK'
        } else if(!this.href) {
            this.linkType = 'EXPANDED_NODE'
        }
    }
}
